import React, {PureComponent, Fragment, useCallback} from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

function withVfRouting(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  //gotta hoist those statics!  This allows us to access class variables that we create.
  hoistNonReactStatics(ComponentWithRouterProp, Component);
  return ComponentWithRouterProp;
}

export default withVfRouting;
